import { fromCents, toCents } from 'modules/core/lib/formatCurrencyUtils'

import { InMemoryAdditionalCompensation } from 'modules/contracts/lib/contractFlowContext'

// TODO: amount now can be not in cents, fix this when we move the transform responsibility to
// input itself

const mapAmountAndUpperLimitToCents = (
  additionalCompensation: InMemoryAdditionalCompensation
): InMemoryAdditionalCompensation => {
  const isMoneyUnit = additionalCompensation.payrollConcept?.unitType === 'money'
  const originalAmountStrategy = additionalCompensation.amountStrategy
  const amountInCents =
    additionalCompensation.amountStrategy?.amount !== null &&
    additionalCompensation.amountStrategy?.amount !== undefined
      ? isMoneyUnit
        ? toCents(additionalCompensation.amountStrategy?.amount)
        : additionalCompensation.amountStrategy?.amount
      : null
  const upperLimitInCents =
    additionalCompensation.amountStrategy &&
    'upperLimit' in additionalCompensation.amountStrategy &&
    additionalCompensation.amountStrategy.upperLimit !== null &&
    additionalCompensation.amountStrategy.upperLimit !== undefined
      ? isMoneyUnit
        ? toCents(additionalCompensation.amountStrategy.upperLimit)
        : additionalCompensation.amountStrategy?.upperLimit
      : null
  return {
    ...additionalCompensation,
    amountStrategy: originalAmountStrategy
      ? {
          ...originalAmountStrategy,
          amount: amountInCents,
          ...(additionalCompensation.amountStrategy &&
          'upperLimit' in additionalCompensation.amountStrategy
            ? { upperLimit: upperLimitInCents }
            : {}),
        }
      : null,
  }
}

const mapAmountAndUpperLimitFromCents = (
  additionalCompensation: InMemoryAdditionalCompensation
): InMemoryAdditionalCompensation => {
  const originalAmountStrategy = additionalCompensation.amountStrategy
  const isMoneyUnit = additionalCompensation.payrollConcept?.unitType === 'money'
  const amountFromCents =
    additionalCompensation.amountStrategy?.amount !== null &&
    additionalCompensation.amountStrategy?.amount !== undefined
      ? isMoneyUnit
        ? fromCents(additionalCompensation.amountStrategy?.amount)
        : additionalCompensation.amountStrategy?.amount
      : null
  const upperLimitFromCents =
    additionalCompensation.amountStrategy &&
    'upperLimit' in additionalCompensation.amountStrategy &&
    additionalCompensation.amountStrategy.upperLimit !== null &&
    additionalCompensation.amountStrategy.upperLimit !== undefined
      ? isMoneyUnit
        ? fromCents(additionalCompensation.amountStrategy.upperLimit)
        : additionalCompensation.amountStrategy.upperLimit
      : null
  return {
    ...additionalCompensation,
    amountStrategy: originalAmountStrategy
      ? {
          ...originalAmountStrategy,
          amount: amountFromCents,
          ...(additionalCompensation.amountStrategy &&
          'upperLimit' in additionalCompensation.amountStrategy
            ? { upperLimit: upperLimitFromCents }
            : {}),
        }
      : null,
  }
}

export { mapAmountAndUpperLimitToCents, mapAmountAndUpperLimitFromCents }
